import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

export default function MediaCard(props) {
  const { comingSoon, description, media = {}, title } = props;
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardActionArea>
        {comingSoon ? (
          <Box sx={{ color: 'white', backgroundColor: '#979aaa', height: 140, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h6">
              Coming soon
            </Typography>
          </Box>
        )
          :
          (<CardMedia
            component="img"
            height="140"
            image={comingSoon ? undefined : media.image}
            alt={comingSoon ? undefined : media.alt}
          />)
        }

        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}